import { render, staticRenderFns } from "./trendingNews.vue?vue&type=template&id=7255aa54&"
import script from "./trendingNews.vue?vue&type=script&lang=js&"
export * from "./trendingNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports